import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import { Button, notification } from 'antd';
import { Loader2 } from 'lucide-react';

import { useVerifySignUpEmail } from '@/hooks/useVerifySignUpEmail';

const VerifyEmail = () => {
  const { search } = useLocation();
  const token = new URLSearchParams(search).get('token');
  const isNewEmail = new URLSearchParams(search).get('new_email');
  const [api, contextHolder] = notification.useNotification();

  const {
    data: verifyResult,
    isPending: verifyLoading,
    error,
  } = useVerifySignUpEmail(token, isNewEmail === 'true');

  const navigate = useNavigate();

  useEffect(() => {
    if (verifyResult) {
      localStorage.removeItem('Authorization');
      localStorage.setItem('Authorization', verifyResult.auth_token);

      api.success({
        message: 'Your email has been verified successfully',
        description: 'Redirecting...',
        duration: 3,
      });

      setTimeout(() => {
        navigate('/patients');
      }, 3000);
    }
  }, [verifyResult]);

  if (!token) {
    return (
      <div className="flex h-[40vh] flex-col items-center justify-center gap-4">
        <p className="text-sm text-gray-500">Invalid verification URL</p>
        <Button onClick={() => navigate('/')}>Back to Home</Button>
      </div>
    );
  }

  return (
    <>
      {contextHolder}
      <div className="flex h-[40vh] flex-col items-center justify-center gap-4">
        {verifyLoading && (
          <>
            <Loader2 className="h-8 w-8 animate-spin" />
            <p className="text-sm text-gray-500">Verifying...</p>
          </>
        )}
        {error && (
          <>
            <h2 className="text-2xl font-medium">Verification Failed</h2>
            <p className="text-sm text-gray-500">
              {'status' in error && error.status === 401 ? 'Invalid token' : 'Something went wrong'}
            </p>
            <Button onClick={() => navigate('/')}>Back to Home</Button>
          </>
        )}
      </div>
    </>
  );
};

export default VerifyEmail;
